import { buildPaginationContext } from "src/components/paginationContext.ts";
import { SubscriptionLogFilterProps, SubscriptionLogPagination } from "src/model/subscriptionLog.ts";

export const { Provider, usePaginationContext } = buildPaginationContext<
  SubscriptionLogPagination,
  SubscriptionLogFilterProps
>();
